import { useCallback } from 'react';
import {
  useGetRelease,
  useReleaseValidation,
  useTracklistValidation,
} from 'pages/Distribution/hooks';
import { analytics, events } from 'services/analytics';
import { SummaryInfo, SummaryLoader } from './components';

type PropsType = {
  releaseId: string;
};

const SummaryContainer = ({ releaseId }: PropsType) => {
  const { currentRelease } = useGetRelease(releaseId);

  const { isValid: isReleaseDetailsValid } = useReleaseValidation(releaseId);
  const { isValid: isTracklistValid } = useTracklistValidation(releaseId);

  const isValid = isReleaseDetailsValid && isTracklistValid;

  const handleSubmitError = useCallback(
    () => analytics.track(events.submitReleaseError()),
    []
  );

  const handleSubmitSuccess = useCallback(
    () => analytics.track(events.releaseSubmitted({ hasUserAudio: false })),
    []
  );

  if (!currentRelease) {
    return <SummaryLoader />;
  }

  return (
    <SummaryInfo
      release={currentRelease}
      submitEnabled={isValid}
      onSubmitSuccess={handleSubmitSuccess}
      onSubmitError={handleSubmitError}
    />
  );
};

export default SummaryContainer;
